import React from 'react';

export default function ReviewScreen({ form, answers, onEdit, onSavePDF, pdfSaved, onGoHome, demoMode }) {
  const isVisible = (q) => {
    if (!q.showIf) return true;
    const ans = answers[q.showIf.id] || '';
    if (q.showIf.notEmpty) return !!ans;
    return ans === q.showIf.value || ans.split('||').includes(q.showIf.value);
  };

  const sections = {};
  form.questions.filter(q => isVisible(q) && !q.hideFromReview).forEach(q => {
    if (!sections[q.section]) sections[q.section] = [];
    sections[q.section].push(q);
  });

  const displayVal = (q, a) => {
    if (q.type === 'consent') return a === 'acknowledged' ? '✓ Acknowledged' : '— Not acknowledged';
    if (q.type === 'checkbox-multi') {
      const selected = a ? a.split('||').filter(Boolean) : [];
      const parts = selected.map(opt => {
        const subFields = q.optionFields && q.optionFields[opt];
        if (subFields) {
          const subVals = subFields.map(f => answers[f.id]).filter(Boolean).join(' – ');
          return subVals ? `${opt} (${subVals})` : opt;
        }
        return opt;
      });
      if (q.optionInitials) {
        Object.entries(q.optionInitials).forEach(([opt, id]) => {
          const init = answers[id];
          if (init) parts.push(`${opt} (${init})`);
        });
      }
      return parts.join(', ') || null;
    }
    if (!a) return null;
    if (q.type === 'signature') return a ? '✓ Signed' : null;
    if (q.type === 'multi-text') {
      return q.fields.map(f => answers[f.id]).filter(Boolean).join(' · ') || null;
    }
    return a;
  };

  return (
    <div className="review-screen">
      <div className="progress-header">
        <h2 style={{ margin: 0 }}>Review: {form.title}</h2>
        <button className="btn-back" style={{ padding: '8px 16px', fontSize: '20px', minWidth: 'auto' }} onClick={onGoHome}>Back to Main Screen</button>
      </div>
      <p className="review-subtitle">Check your answers below. Tap Edit to make changes, then save your PDF.</p>
      {Object.entries(sections).map(([section, qs]) => (
        <div className="review-card" key={section}>
          <div className="review-section">
            <h3>{section}</h3>
            {qs.map(q => {
              if (q.type === 'yndk-batch') {
                return q.items.flatMap(item => {
                  const val = answers[item.id];
                  const rows = [(
                    <div className="review-item" key={item.id}>
                      <div className="review-q">{item.label}</div>
                      <div className={`review-a ${!val ? 'empty' : ''}`}>{val || 'Not answered'}</div>
                      <button className="review-edit-btn" onClick={() => onEdit(q.id)}>Edit</button>
                    </div>
                  )];
                  if (item.followUp && val === item.followUp.showIf) {
                    const fuVal = answers[item.followUp.id];
                    rows.push(
                      <div className="review-item" key={item.followUp.id}>
                        <div className="review-q">{item.followUp.label}</div>
                        <div className={`review-a ${!fuVal ? 'empty' : ''}`}>{fuVal || 'Not answered'}</div>
                        <button className="review-edit-btn" onClick={() => onEdit(q.id)}>Edit</button>
                      </div>
                    );
                  }
                  return rows;
                });
              }
              if (q.type === 'multi-text') {
                const val = q.fields.map(f => answers[f.id]).filter(Boolean).join(' · ');
                return (
                  <div className="review-item" key={q.id}>
                    <div className="review-q">{q.label}</div>
                    <div className={`review-a ${!val ? 'empty' : ''}`}>{val || 'Not answered'}</div>
                    <button className="review-edit-btn" onClick={() => onEdit(q.id)}>Edit</button>
                  </div>
                );
              }
              const rawVal = answers[q.id];
              const dv = displayVal(q, rawVal);
              return (
                <div className="review-item" key={q.id}>
                  <div className="review-q">{q.label || q.title}</div>
                  <div className={`review-a ${!dv ? 'empty' : ''}`}>{dv || 'Not answered'}</div>
                  <button className="review-edit-btn" onClick={() => onEdit(q.id)}>Edit</button>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <button className="btn-save-pdf" onClick={onSavePDF} disabled={demoMode}>
        {demoMode ? 'Saving disabled (demo)' : `⬇ Save & Download ${form.title} PDF`}
      </button>
      {pdfSaved && (
        <p style={{ textAlign: 'center', marginTop: 12, color: 'var(--green)', fontWeight: 600, fontSize: 17 }}>
          PDF Downloaded.
        </p>
      )}
      <button className="btn-back" style={{ display: 'block', margin: '16px auto 0' }} onClick={onGoHome}>Back to Main Screen</button>
    </div>
  );
}
